import { initApp } from '@/app';

// Асинхронная инициализация приложения
// Загружает runtime конфигурацию перед стартом
initApp().catch((error) => {
  console.error('Failed to initialize app:', error);
});
